import Helmet from 'react-helmet';
import { Route, Routes } from 'react-router-dom';
import ComeDineWithMe from './components/comedinewithme/comedinewithme.tsx';
import ComeDineWithMeFull from './components/comedinewithme/comedinewithmefull.tsx';
import HomeWrapper from './components/home/HomeWrapper.tsx';
import Orisit from './components/orisit/Orisit.tsx';
import Random from './components/random/random.tsx';

function App() {
   return (
      <div className='application'>
         <Helmet>
            <title>Routing</title>
         </Helmet>
         <Routes>
            <Route path='/' element={<HomeWrapper />} />
            <Route path='/comedinewithmefull' element={<ComeDineWithMeFull />} />
            <Route path='/comedinewithme' element={<ComeDineWithMe />} />
            <Route path='/reddit/random' element={<Random />} />
            <Route path='/reddit/random/top' element={<Random sortFromUrl='top' />} />
            <Route path='/reddit/random/hot' element={<Random sortFromUrl='hot' />} />
            {/* Legacy */}
            <Route path='/randomreddit' element={<Random sortFromUrl='top' overrideDepth={20000} />} />
            <Route path='/randomreddit100' element={<Random sortFromUrl='top' overrideDepth={2000} />} />
            <Route path='/randomreddit200' element={<Random sortFromUrl='top' overrideDepth={10000} />} />
            <Route path='/orisit/:key' element={<Orisit />} />
         </Routes>
      </div>
   );
}

export default App;
